import { isEmpty } from "lodash";
import React from "react";

import { type DropdownItem, MultiStateButton } from "../../../../components/buttons/multiStateButton/MultiStateButton";
import RestrictedByTooltip from "../../../../components/restrictedByTooltip/RestrictedByTooltip";
import { type RolePermissions } from "../../../../enums";
import Restricted from "../../../Application/Restricted";
import styles from "./addUserButton.module.scss";
import { Tooltip } from "components/common/tooltip";

export interface AddUserButtonProps {
  shouldRender: boolean;
  createPermissions: RolePermissions[];
  permissionPredicate?: (userPermissions: string[]) => boolean;
  onCreateUser?: () => void;
  onImportUsers?: () => void;
  onRemoveUsers?: () => void;
  buttonText?: string;
  createUserText?: string;
  importUsersText?: string;
  disabled?: boolean;
  tooltipText?: string;
  tooltipPosition?: string;
}

const AddUserButton: React.FC<AddUserButtonProps> = ({
  shouldRender,
  createPermissions,
  permissionPredicate,
  onCreateUser,
  onImportUsers,
  onRemoveUsers,
  disabled,
  tooltipText,
  tooltipPosition = "left center",
  buttonText = "Add Users",
  createUserText = "Manually Create",
  importUsersText = "Import CSV",
}) => {
  const getMenuItems = (): DropdownItem[] =>
    [
      onCreateUser && { icon: "user-plus", text: createUserText, onClick: onCreateUser },
      onImportUsers && { icon: "file-import", text: importUsersText, onClick: onImportUsers },
      onRemoveUsers && { icon: "file-export", text: "Remove via CSV", onClick: onRemoveUsers },
    ].filter(Boolean) as DropdownItem[];

  if (shouldRender) {
    return (
      <Restricted
        permissions={createPermissions}
        permissionPredicate={permissionPredicate}
        renderContent={(hasAnyPermission) => (
          <RestrictedByTooltip
            hasPermission={hasAnyPermission}
            className="create-button user"
            tooltipPosition={tooltipPosition}
          >
            <Tooltip
              content={tooltipText}
              showAlways={!isEmpty(tooltipText)}
              position={tooltipPosition}
              target={
                <MultiStateButton
                  className={styles.root}
                  id="add-users"
                  trigger={buttonText}
                  simple
                  items={getMenuItems()}
                  disabled={!hasAnyPermission || disabled}
                />
              }
            />
          </RestrictedByTooltip>
        )}
      />
    );
  }
  return null;
};

export default AddUserButton;
